import { gql } from '~/__generated__'

export const GET_PLAYLISTS = gql(`
  query getPlaylists {
    playlists {
      id
      title
    }
  }
`)

export const GET_VIDEO_PLAYLISTS = gql(`
  query getVideoPlaylists($videoId: ID!) {
    originalVideo(id: $videoId) {
      id
      playlistsVideos {
        id
        playlist {
          id
        }
      }
    }
  }
`)
